import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {ReplaySubject} from 'rxjs';
import {PersonalDataChange} from '../../../shared/interface/personalDataChange';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {PersonalDataChangeService} from '../../../shared/services/personal-data-change.service';
import {Document} from "../../../shared/interface/document";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {DocumentAddDialogComponent} from "../../documents/document-add-dialog/document-add-dialog.component";
import {
  FILE_TYPE_CONFIRMATION_PERSONAL_DATA_CHANGE,
  FILE_TYPE_PERSONAL_DATA_CHANGE
} from "../../../shared/services/dict.service";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";

@Component({
  selector: 'app-personal-data-change-details',
  templateUrl: './personal-data-change-details.component.html',
  styleUrls: ['./personal-data-change-details.component.scss'],
})
export class PersonalDataChangeDetailsComponent implements OnInit, OnDestroy {
  uuid?: string = null;
  personalDataChangeObject?: PersonalDataChange;
  personalDataChange: ReplaySubject<PersonalDataChange> = new ReplaySubject<PersonalDataChange>(1);
  documents: ReplaySubject<Document[]> = new ReplaySubject<Document[]>(1);
  modify = false;
  personalDataChangeId: string;
  userPermissions: ReplaySubject<UserPermissions>;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private personalDataChangeService: PersonalDataChangeService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.personalDataChangeId = params.id;
        this.loadPersonalDataChange();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
    if (e.index === 0) {
      this.loadPersonalDataChange();
    }
    if (e.index === 1) {
      this.loadDocuments();
    }
  }

  loadPersonalDataChange(): void {
    this.personalDataChangeService.get(this.personalDataChangeId).subscribe((personalDataChange: PersonalDataChange) => {
      this.personalDataChange.next(personalDataChange);
      this.personalDataChangeObject = personalDataChange;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });
    });
  }

  loadDocuments(): void {
    this.personalDataChangeService.getPersonalDataChangeDocuments(this.personalDataChangeId)
      .subscribe((documents: ListResponse<Document>) => {
        this.documents.next(documents.items);
      });
  }

  addDocument(): void {
    const dialogRef = this.dialog.open(DocumentAddDialogComponent, {
      width: '55%',
      data: {
        personalDataChangeObject: this.personalDataChangeObject,
        types: [FILE_TYPE_PERSONAL_DATA_CHANGE, FILE_TYPE_CONFIRMATION_PERSONAL_DATA_CHANGE],
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadDocuments();
      this.loadPersonalDataChange();
    });
  }

}
